import React, { createContext, useContext, useState, useEffect } from "react";
import { getCurrentUser } from "../api/auth";

export interface User {
  id: number;
  username: string;
  fullName?: string;
  email?: string;
  role?: 'user' | 'admin' | 'superadmin' | 'super_admin';
  client_id?: number | null;
  organization_id?: number | null;
  language?: string;
}

interface UserContextType {
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
  language: string;
  setLanguage: React.Dispatch<React.SetStateAction<string>>;
}

const LANGUAGE_MAPPING: Record<string, string> = {
  "IT": "Italian",
  "FR": "French",
  "EN": "English"
};

const UserContext = createContext<UserContextType | undefined>(undefined);
export const UserProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [language, setLanguage] = useState<string>("Italian");

  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      getCurrentUser()
        .then((data) => {
          setUser({
            id: data.id,
            username: data.username,
            fullName: data.full_name,
            email: data.email,
            role: data.role || 'user',
            language: data.language
          });
          
          if (data.language && LANGUAGE_MAPPING[data.language]) {
            setLanguage(LANGUAGE_MAPPING[data.language]);
          }
        })
        .catch(() => setUser(null));
    }
  }, []);
  
  return (  
    <UserContext.Provider value={{ user, setUser, language, setLanguage }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser должен использоваться внутри UserProvider");
  }

  return context;
};